export var BorderRadius;
(function (BorderRadius) {
    BorderRadius["XS"] = "2px";
    BorderRadius["S"] = "4px";
    BorderRadius["M"] = "8px";
    BorderRadius["L"] = "16px";
    BorderRadius["BUTTON"] = "25px";
})(BorderRadius || (BorderRadius = {}));
export const Border = {
    Base: '1px solid',
    BaseDouble: '2px solid',
    Radius: BorderRadius,
};
//# sourceMappingURL=border.js.map